import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Modal from "../../components/Modal";
import { Spinner } from "../../components/Loader";
import { getSites } from "../../services/sites";
import { useDebounced } from "../../utils/hooks";

// Overview: one "Order management" button. It asks which website's orders to open (searchable, so a Super Admin
// with every store can find one), then opens Manage orders for it.
export default function OrderQuickLinks({ user }) {
  const navigate = useNavigate();
  const isSuper = user.role === "superadmin";
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState("");
  const search = useDebounced(query, 300).trim();
  const [sites, setSites] = useState(null); // null while loading
  const [error, setError] = useState("");

  useEffect(() => {
    if (!open) return undefined;
    let live = true;
    setSites(null);
    setError("");
    getSites({ search: search || undefined, limit: 20, sort: "name", ...(isSuper ? { demo: "include" } : {}) })
      .then(({ data }) => live && setSites(data.sites))
      .catch(() => live && (setSites([]), setError("Could not load your websites. Try again.")));
    return () => { live = false; };
  }, [open, search, isSuper]);

  const close = () => { setOpen(false); setQuery(""); };

  return (
    <section className="panel order-links tab-gap">
      <div className="panel-heading">
        <div><h2>Order management</h2><p>See, confirm and ship your orders.</p></div>
        <button className="primary-btn" onClick={() => setOpen(true)}>📦 Order management</button>
      </div>

      {open && (
        <Modal eyebrow="ORDER MANAGEMENT" title="Choose a website" description="Whose orders do you want to manage?" onClose={close}>
          <input className="order-site-search" type="search" value={query} onChange={(e) => setQuery(e.target.value)} placeholder="Search websites by name…" aria-label="Search websites" autoFocus />
          {error && <div className="admin-error">{error}</div>}
          {sites === null ? (
            <div className="order-site-loading"><Spinner /> Loading websites</div>
          ) : !sites.length ? (
            !error && <p className="order-links-empty">{search ? `No website matches "${search}".` : "You have no websites yet."}</p>
          ) : (
            <ul className="order-site-list">
              {sites.map((site) => (
                <li key={site.id}>
                  <button onClick={() => navigate(`/admin/sites/${site.id}/orders`)}>
                    <span className="site-mark">{(site.name || "S").slice(0, 1)}</span>
                    <span className="order-site-name"><b>{site.name}</b><small>{site.domain || site.id}</small></span>
                    <span aria-hidden="true">→</span>
                  </button>
                </li>
              ))}
            </ul>
          )}
        </Modal>
      )}
    </section>
  );
}
